/**
 * The sidebar's navigation rules that are not about rendering, shared with the header search so
 * both list exactly the same destinations: legacy route repoints and the recruitment-stack
 * dark launch.
 */

/**
 * Legacy → v2 nav repoints.
 *
 * The sidebar's routes are entirely DB-driven (sub_category.route_path, delivered via the login
 * payload into sessionStorage.operations). To repoint a nav entry to a new screen without a
 * backend/DB migration, known legacy route paths are swapped for the new destination while the
 * underlying permission-gated menu entry (label, ordering, RBAC gating) stays untouched.
 *
 * Permission → Leave V2 cutover (R1): the legacy `/permission` page (route still registered for
 * rollback/history) is repointed to the v2 apply screen pre-selecting the Permission leave type.
 */
export const LEGACY_ROUTE_REPOINTS: Record<string, string> = {
  '/permission': '/leave/my/apply?type=permission'
};

export function resolveMenuRoute(routePath: string | undefined | null): string | undefined {
  if (!routePath) return routePath || undefined;
  // Normalise a trailing slash before matching ("/permission/" -> "/permission")
  const normalised = routePath.length > 1 && routePath.endsWith('/') ? routePath.slice(0, -1) : routePath;
  return LEGACY_ROUTE_REPOINTS[normalised] ?? routePath;
}

// Dark-launch: menu entries for the recruitment / onboarding / vendor stack are hidden unless the
// tenant recruitment flag is on. Matches on route path so DB-seeded entries need no extra marker.
const RECRUITMENT_STACK_ROUTE = /^\/(recruitment|onboarding-admin|offer-letters-onboarding)(\/|$)/;
export const isRecruitmentStackPath = (p?: string) => !!p && RECRUITMENT_STACK_ROUTE.test(p);
